export default class CookieCheckbox {

    constructor(element, CookieBar) {
        this.element = element
        this.CookieBar = CookieBar
        
        this.CookieBar.options = this.CookieBar.options || []
        this.CookieBar.options.push(this)

        this.checkbox = this.element.querySelector('input')
        !this.checkbox.disabled && this.element.addEventListener('click', this.onClick.bind(this))

        this.checkbox.checked && this.element.classList.toggle('checked')
        this.checkbox.disabled && this.element.classList.toggle('disabled')
    }

    onClick() {
        this.element.classList.toggle('checked')
        this.checkbox.checked = !this.checkbox.checked
    }
}
